module.exports = __webpack_public_path__ + "images/a073b172631b94ec91335499d67f47ce-CSP_SilverBadge.png";